import { IAevoPosition, ICollateral } from "../../../interfaces/aevo";
import { ISubaccount } from "../../../hooks/api/admin/useSubaccounts";
import { formatAmount } from "../../../utils/strings";

export interface IAccountTotals {
  // USD value of all collateral, before unrealized PnL
  collateral: number;
  upnl: number;
  maintenanceMargin: number;
  positions: number;
}

export const EMPTY_TOTALS: IAccountTotals = { collateral: 0, upnl: 0, maintenanceMargin: 0, positions: 0 };

export const accountTotals = (balances: ICollateral[] = [], positions: IAevoPosition[] = []): IAccountTotals => ({
  collateral: balances.reduce((sum, b) => sum + (Number(b.collateral_value) || 0), 0),
  upnl: positions.reduce((sum, p) => sum + (Number(p.unrealized_pnl) || 0), 0),
  maintenanceMargin: positions.reduce((sum, p) => sum + (Number(p.maintenance_margin) || 0), 0),
  positions: positions.length,
});

export const addTotals = (a: IAccountTotals, b: IAccountTotals): IAccountTotals => ({
  collateral: a.collateral + b.collateral,
  upnl: a.upnl + b.upnl,
  maintenanceMargin: a.maintenanceMargin + b.maintenanceMargin,
  positions: a.positions + b.positions,
});

export const subaccountTotals = (subaccounts: ISubaccount[]) =>
  subaccounts.reduce((sum, sub) => addTotals(sum, accountTotals(sub.balances, sub.positions)), EMPTY_TOTALS);

// "$1.07M", "-$8.12K"; compact so totals fit in the account family bar
export const formatUsd = (value: number) => `${value < 0 ? "-" : ""}$${formatAmount(Math.abs(value))}`;

export const pluralize = (count: number, noun: string) => `${count} ${noun}${count === 1 ? "" : "s"}`;

// Archived subaccounts go last; otherwise keep the backend's creation order
export const sortSubaccounts = (subaccounts: ISubaccount[]) =>
  [...subaccounts].sort((a, b) => Number(a.archived) - Number(b.archived));
